import marked from 'marked';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import AppState, { SCREENS } from '../../AppState';
import SequencesManager from '../../SequencesManager/SequencesManager';
import Button from '../Button/Button';
import NextButton from '../Button/NextButton/NextButton';
import EnterButton from '../Button/EnterButton/EnterButton';
import SoundButton from '../Button/SoundButton/SoundButton';
import StartButton from '../Button/StartButton/StartButton';
import logo from '../../images/Logo.png'
import Translations from "../../Translations"
import Speech from '../../SpeechLib/Speech';
import SpeechDisplayer from '../SpeechDisplayer/SpeechDisplayer';

import './QuizScreen.css';

const {root, imagesFolder} = window.CONFIG

const Answer = ({a, isActive, isCorrect, isSelected, selectedAnswers, onMouseEnter, onClick, onValidate}) => {

  let cl = "choice-text"

  if(selectedAnswers && selectedAnswers.includes(a.id))
  {

    if(a.raw.correct_answer) {
      cl += " inactive correct"

    }
    else {
      cl += " inactive wrong"
    }
  }
  else if(isCorrect) {
      cl += " inactive"
  }
  else if(isSelected) {
      cl += " selected"
  }
  else if(!isActive) {
      cl += " inactive"
  }

  return (
      <div className='choice'>
        <Button onMouseEnter={onMouseEnter} onClick={onClick}  className={cl} >
          {a.raw.Text}
        </Button >
        {isSelected && <EnterButton onClick={onValidate} />}
      </div>
  );
}

/*
le principe
c'est le moment de la question : les datas sont mises dans "currentDial"
puis on répond : la question est mise dans "question", le feedback dans "currentDial"
*/
const QuizScreen = (data, title) => {

  const questionRef = useRef(null)
  const feedbackRef = useRef(null)
  const questionsCountRef = useRef(null)
  const [currentChoices, setCurrentChoices] = useState([]);

  const [character, setCharacter] = useState(Speech.getCharacter("marieJo"))
  const [isDial, setIsDial] = useState(true);
  const [isSpeaking, setisSpeaking] = useState(false);
  const [answerSelected, setAnswerSelected] = useState(null);
  const [answered, setAnswered] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [score, setScore] = useState(0);
  const [currentDial, setCurrentDial] = useState(null);
  const [finished, setFinished] = useState(false);
  const [questionCount, setQuestionCount] = useState(1);
  // permet juste de refresh l'interfae quand on utilise les objets de la sequenceManager qui ne sont pas trackés par react
  const [refreshToken, setRefreshToken] = useState(0);
  const [fullscreenImage, setFullscreenImage] = useState(null);

 // NOTE(g) useMemo pour ne calculer ce ratio que quand la valeur de finished change.
  // C'est plus pour le test car ca ne consomme pas tant que ça, cette division
  const ratio = useMemo(() => {
    return score / questionsCountRef.current
  }, [finished])

  useEffect(() => {
    setRefreshToken(0)

    SequencesManager.playFile("quiz")
    questionsCountRef.current = countQuestions(SequencesManager.currentSequence.getCurrentFile().elements)
    setCurrentDial(SequencesManager.getCurrentElement())

  }, []);

  useEffect(() => {
    if(currentDial) {
      if (currentDial.Type === "choice_title") {
        playQuestion()
      }
      else if(currentDial.Type === null) {
        Speech.queueDialog(character, SequencesManager.getCurrentElement().id, refresh.bind(this))
      }
    }
  }, [currentDial]);

  useEffect(() => {

  }, [refreshToken]);

  function countQuestions(data) {
    return data.filter(row => row.Type === "choice_title").length
  }

  function parseMarkdown(t) {

    if(t == null)
      return null;

    let opts = { linkTargetBlank: true, noParagraph: true}
    const renderer = new marked.Renderer();

    if(opts.linkTargetBlank) {
      const linkRenderer = renderer.link;
      renderer.link = (href, title, text) => linkRenderer.call(renderer, href, title, text).replace(/^<a /, '<a target="_blank" rel="nofollow" ')
    }
    if(opts.noParagraph) { renderer.paragraph = text => text + '\n' }
    return marked(t, {renderer})
  }

  function _next() {
    setRefreshToken(rt => rt + 1)

    setAnswered(false)
    setIsCorrect(false)

    if(SequencesManager.hasNext()) {
      let wasQuestion = currentDial? currentDial.Type === "choice_title" : false
      let next = SequencesManager.next()

      setCurrentDial(next)
      let isDial = next.Type === null
      setIsDial(isDial)
      if(isDial && wasQuestion) setFinished(true)
    }
    else {
      replay()
      // Speech.playDialog(character, "replay", replay.bind(this))
      return;
    }
  }

  function replay() {
    AppState.loadQuiz()
  }

  function playQuestion() {
    setisSpeaking(true)

    let choices = currentDial.getAllChoices()
    Speech.queueDialog(character, currentDial.id, showQuestionChoice.bind(this, choices[0]))
    Speech.queueDialog(character, choices[0].id, showQuestionChoice.bind(this, choices[1]))
    Speech.queueDialog(character, choices[1].id, showQuestionChoice.bind(this, choices[2]))
    Speech.queueDialog(character, choices[2].id, questionAsked.bind(this))
  }

  function showQuestionChoice(choice) {
    currentChoices.push(choice.id)

    setRefreshToken(rt => rt + 1)
  }

  function replayQuestion() {

    if(isSpeaking) return;

    setisSpeaking(true)
    Speech.queueDialog(character, currentDial.id, questionAsked.bind(this))
  }

  function questionAsked() {
    setisSpeaking(false)
  }

  function refresh() {
    setRefreshToken(rt => rt + 1)
  }

  function handleChoiceClick(a) {
    Speech.playDialog(character, a.id, null)
    setAnswerSelected(a)
  }

  function handleNextClick() {
    _next()
    setRefreshToken(rt => rt + 1)
  }

  function handleEnterClick(a) {
    // let a = answerSelected

    setAnswerSelected(null)

    if(a.raw.correct_answer) {
      if(!answered) setScore(s => s+1)
      setIsCorrect(true)

      // setTimeout(_next, 1)
      Speech.playDialog(character, "right", null)
    }
    else {
      Speech.playDialog(character, "wrong", null)
    }

    setAnswered(true)

    currentDial.addAnswer(a.id)
    setRefreshToken(rt => rt + 1)
  }

  useEffect(() => {
    if(answered) {
      feedbackRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [answered])

  function getImagesPaths(images) {
    if(!images) return []
    return images.split(";").map(image_name => {
      return root + imagesFolder + image_name
    })
  }

  function scrollToQuestion() {
    questionRef.current.scrollIntoView({ behavior: 'smooth' })
  }

  function setFullScreen(a) {
      setFullscreenImage(a);
  }

  return (
    <div className="QuizScreen" >
      <div className="quiz-left"> {
        <div className="Character">
          <SpeechDisplayer character={character}/>
        </div>}
      </div>

      <div className="quiz-ctnr">
        {finished && <div className="QuizScreen-end">
          <div className="title"> Score </div>
          <div className="Container">
            <div className="score-end"> <span>{score}</span>/{questionsCountRef.current} </div>
            <div className="text" dangerouslySetInnerHTML={{__html: parseMarkdown(currentDial.raw.Text)}} />
          </div>
        </div>}

        {!finished && currentDial && <div className="question" >
          {<div className="QuizScreen-top">
            <div className="score">
              Score : <span>{score}</span> / {questionsCountRef.current}
            </div>
          </div>}

          {currentDial.Type !== "choice_title" && <div className={"intro-text"} ref={questionRef}>
            <div className="text" dangerouslySetInnerHTML={{__html: parseMarkdown(currentDial.raw.Text)}} />
          </div>}

         {currentDial.Type === "choice_title" && <div className={"question-text"} ref={questionRef}>
            <div className="question-replay"> {
              <SoundButton onClick={replayQuestion} />
            }</div>
            <div className="question-images"> {
              getImagesPaths(currentDial.raw.images)
              .map(img => <img onLoad={scrollToQuestion} key={img} src={img} alt="" onClick={() => setFullScreen(img)} />)}
            </div>
            <div className="text" dangerouslySetInnerHTML={{__html: parseMarkdown(currentDial.raw.Text)}} />
          </div>}
          {currentDial.Type === "choice_title" && <div className="question-choices" > {
            currentDial.getAllChoices().map(a =>
              currentChoices.indexOf(a.id) != -1 &&
                <Answer key={a.id} a={a} isActive={!isSpeaking} isSelected={answerSelected == a} isCorrect={isCorrect} selectedAnswers={currentDial.getAllAnswerIds()} onClick={() => handleChoiceClick(a)} onValidate={()=> handleEnterClick(a)} />)}
            </div>}
            {answered && <div ref={feedbackRef} className={"question-feedback " + (isCorrect? "right" : "wrong")}
                              dangerouslySetInnerHTML={{__html: Translations.get(isCorrect? "Correct" : "Wrong", "de")}} />}

        {isDial && refreshToken === 1 && <div className="button-start">
          <StartButton onClick={handleNextClick} />
        </div>}
        </div>}
      </div>
      <div className="quiz-right">
          <div className="logo">
            <img src={logo} />
          </div>

       <div className="bottom-block">
          {(isCorrect || isDial) && refreshToken > 2 && !answerSelected && <div className="button-next">
            <NextButton onClick={handleNextClick} />
          </div>}
          <div className="links">
            <a href="https://www.goethe.de/ins/es/de/dat.html" target="_blank">Datenschutz</a>
            <a href="https://www.goethe.de/ins/es/de/imp.html" target="_blank">Impressum</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuizScreen;
